import { ReactNode } from "react";
import { useFeatureFlags } from "./feature-flags";

interface FeatureGateProps {
  /**
   * The feature flag name (a FEATURE_FLAGS entry)
   */
  flag: string;
  /**
   * Optional content to render when flag is disabled
   */
  fallback?: ReactNode;
  /**
   * Content to render when flag is enabled
   */
  children: ReactNode;
}

/**
 * Component for conditional rendering based on feature flags
 *
 * @example
 * ```tsx
 * <FeatureGate flag={FEATURE_FLAGS.AI_SCHEDULER}>
 *   <AIAssistantWidget />
 * </FeatureGate>
 * ```
 */
export function FeatureGate({ flag, fallback = null, children }: FeatureGateProps) {
  const { getBooleanFlag } = useFeatureFlags();
  const isEnabled = getBooleanFlag(flag);

  return isEnabled ? <>{children}</> : <>{fallback}</>;
}
